import { cva } from '@/styled-system/css';

export const textButtonIconRecipe = cva({
  base: {},

  variants: {
    tone: {
      'brand': {
        color: { base: 'TextButton.brand.icon.default' },
      },
      'neutral': {
        color: { base: 'icon.neutral' },
      },
      'neutral-fixed': {
        color: { base: 'icon.action.neutral-fixed.default' },
      },
      'subtle': {
        color: { base: 'icon.subtle' },
      },
      'critical': {
        color: { base: 'icon.action.critical.hero.default' },
      },
    },
    onImpact: {
      true: {},
      false: {},
    },
    disabled: {
      true: {},
      false: {},
    },
    size: {
      sm: {},
      md: {},
    },
  },

  compoundVariants: [
    {
      tone: 'brand',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.brand.icon.hover',
          _groupActive: 'TextButton.brand.icon.pressed',
        },
      },
    },
    {
      tone: 'neutral',
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.neutral',
          _groupActive: 'icon.neutral',
        },
      },
    },
    {
      tone: 'subtle',
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.subtle',
          _groupActive: 'icon.subtle',
        },
      },
    },
    {
      tone: 'critical',
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.action.critical.hero.hover',
          _groupActive: 'icon.action.critical.hero.pressed',
        },
      },
    },
    {
      tone: 'neutral-fixed',
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.action.neutral-fixed.hover',
          _groupActive: 'icon.action.neutral-fixed.pressed',
        },
      },
    },
    {
      tone: 'neutral',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'icon.onImpact.action.neutral.default',
          _groupHover: 'icon.onImpact.action.neutral.hover',
          _groupActive: 'icon.onImpact.action.neutral.pressed',
        },
      },
    },
    {
      tone: 'brand',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'icon.onImpact.action.hero.default',
          _groupHover: 'icon.onImpact.action.hero.hover',
          _groupActive: 'icon.onImpact.action.hero.pressed',
        },
      },
    },
    {
      tone: 'critical',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'icon.onImpact.action.critical.hero.default',
          _groupHover: 'icon.onImpact.action.critical.hero.hover',
          _groupActive: 'icon.onImpact.action.critical.hero.pressed',
        },
      },
    },
    {
      tone: 'neutral-fixed',
      onImpact: true,
      disabled: false,
      css: {
        color: {
          base: 'icon.onImpact.neutral-fixed',
          _groupHover: 'icon.onImpact.neutral-fixed',
          _groupActive: 'icon.onImpact.neutral-fixed',
        },
      },
    },
    {
      tone: 'brand',
      onImpact: true,
      disabled: true,
      css: {
        color: {
          base: 'icon.onImpact.action.hero.default',
        },
      },
    },
    {
      tone: 'neutral',
      onImpact: true,
      disabled: true,
      css: {
        color: {
          base: 'icon.onImpact.action.neutral.default',
        },
      },
    },
    {
      tone: 'critical',
      onImpact: true,
      disabled: true,
      css: {
        color: {
          base: 'icon.onImpact.action.critical.hero.default',
        },
      },
    },
  ],
});
